import type { AffiliatePayoutMethod } from '@/types/affiliates'
export const DOEY_GATEWAY_REQUIRED_MESSAGE =
  'O usuário precisa configurar o Gateway de Pagamento com o ID Doey antes de credenciar com repasse automático.'

export function getAutomaticDoeyUserId(doeyUserId: string | null | undefined): string | null {
  const trimmed = doeyUserId?.trim() ?? ''
  return trimmed !== '' ? trimmed : null
}

export function getInstitutionDefaultDoeyUserId(
  sellerId: string | null | undefined
): string | null {
  const trimmed = sellerId?.trim() ?? ''
  return trimmed !== '' ? trimmed : null
}

export function institutionHasDoeyGatewayConfigured(
  sellerId: string | null | undefined
): boolean {
  return getInstitutionDefaultDoeyUserId(sellerId) !== null
}

export type ApplyDoeyAfterUserSearchResult =
  | { ok: true; doeyUserId: string }
  | { ok: false; gatewayError: string }

export function applyDoeyUserIdAfterUserSearch(
  payoutMethod: AffiliatePayoutMethod,
  searchedUserDoeyUserId: string | null | undefined
): ApplyDoeyAfterUserSearchResult {
  if (payoutMethod !== 'doey') {
    return { ok: true, doeyUserId: '' }
  }

  const resolved = getAutomaticDoeyUserId(searchedUserDoeyUserId)
  if (resolved === null) {
    return { ok: false, gatewayError: DOEY_GATEWAY_REQUIRED_MESSAGE }
  }

  return { ok: true, doeyUserId: resolved }
}

export function canSubmitWithDoeyPayout(
  payoutMethod: AffiliatePayoutMethod,
  doeyUserId: string | null | undefined
): boolean {
  if (payoutMethod !== 'doey') {
    return true
  }

  return getAutomaticDoeyUserId(doeyUserId) !== null
}

/**
 * Credenciamento novo ou troca para Doey exige gateway; edição de registro já Doey pode seguir com ID legado.
 */
export function canSubmitCredentialFormWithDoeyPayout(
  isEdit: boolean,
  payoutMethod: AffiliatePayoutMethod,
  doeyUserId: string | null | undefined,
  existingPayoutMethod?: AffiliatePayoutMethod,
  existingDoeyUserId?: string | null
): boolean {
  if (canSubmitWithDoeyPayout(payoutMethod, doeyUserId)) {
    return true
  }

  if (
    isEdit &&
    payoutMethod === 'doey' &&
    existingPayoutMethod === 'doey' &&
    Boolean(existingDoeyUserId?.trim())
  ) {
    return true
  }

  return false
}
